// extracted by mini-css-extract-plugin
export default {"container":"InputTextArea_container__LeDhw","labelText":"InputTextArea_labelText__fTk2P","required":"InputTextArea_required__DfVVX","inputText":"InputTextArea_inputText__xz43u"};